import React, { useState } from "react";
import {
  Box,
  Modal,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { generateOtp, requestPasswordReset } from "../redux/action/otp";
import { useNavigate } from "react-router-dom";
import { unwrapResult } from "@reduxjs/toolkit";

const ForgotPasswordModal = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email) {
      setError("Email is required");
      return;
    }

    setIsLoading(true);
    setError("");

    await dispatch<any>(requestPasswordReset(email))
      .then(unwrapResult)
      .then((res: any) => {
        setIsLoading(false);
        navigate(
          `/${res.carrier.business_name}/${res.carrier.canonical_id}/otp-verification`,
          {
            state: { email, isPasswordReset: true },
          }
        );
      })
      .catch((err: any) => {
        setIsLoading(false);
        setError(err || "Failed to send OTP");
      });
  };

  const [emailError, setEmailError] = useState("");
  const validateEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!email || !emailRegex.test(email)) {
      setEmailError("Invalid Email");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };
  const handleEmailChange = (e: any) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!validateEmail(newEmail)) {
      setEmailError("Invalid Email");
    } else {
      setEmailError("");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Forgot Password
        </Typography>
        <Typography variant="body2" color="textSecondary" mb={2}>
          Enter your Email to receive a password reset OTP
        </Typography>

        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          value={email}
          error={Boolean(emailError)}
          onChange={handleEmailChange}
          sx={{ mb: 2 }}
        />

        {error && (
          <Typography color="error" sx={{ mb: 2 }}>
            {error}.
          </Typography>
        )}

        <Button
          variant="contained"
          fullWidth
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={24} /> : "Send OTP"}
        </Button>
      </Box>
    </Modal>
  );
};

export default ForgotPasswordModal;
